import { FETCH_FIXTURE_CIRCUIT_CONFIG } from "../../constants/fixtureCircuitConfig";
import { feeds } from "../../apis/services";

export const fetchFixtureCircuitConfig = (params) => ({
  type: FETCH_FIXTURE_CIRCUIT_CONFIG,
  payload: feeds.getFixtureCircuitConfigV2(params),
});
